import { IconName, IconNameType } from '@octano/global-ui';

export default function isIcon(icon: any): icon is IconNameType {
  return Boolean(IconName[(icon as any) as keyof typeof IconName]);
}
